import JSZip from 'jszip';
import { XMLParser } from 'fast-xml-parser';
import * as HtmlParsing from "./HtmlParsing";
import {aiStore} from "../../index";
import {handleAbort} from "./PdfParser";

async function extractOdtZip(buffer) {
    const zip = new JSZip();
    return await zip.loadAsync(buffer);
}

async function extractImages(zip, file, isEmbedding, abortedFiles) {
    const imageMap = {};
    const imageEntries = [];


    zip.forEach((relativePath, zipEntry) => {
        if (relativePath.startsWith('Pictures/') && !zipEntry.dir) {
            imageEntries.push({ path: relativePath, entry: zipEntry });
        }
    });
    const imagesCount = imageEntries.length
    for (const [index, { path, entry }] of imageEntries.entries()) {
        try {
            if (handleAbort(file, abortedFiles, isEmbedding)) {
                return [];
            }
            const name = path.split('/').pop();
            const extension = name.split('.').pop().toLowerCase();
            const arrayBuffer = await entry.async('arraybuffer');
            const blob = new Blob([arrayBuffer], { type: `image/${extension}` });
            const fileId = await HtmlParsing.uploadImageFromFile(blob, file, index, extension);

            if (fileId) {
                imageMap[path] = fileId;
            }
        } catch (error) {
        }
        aiStore.sendAiProgressLoaderValue(file.name, (index+1)*100/(imagesCount+2))
    }

    return imageMap;
}


async function extractContentXml(zip) {
    const entry = zip.file('content.xml');
    if (!entry) throw new Error('content.xml not found');
    return await entry.async('string');
}

async function parseContentXml(xmlString) {
    const parser = new XMLParser({ ignoreAttributes: false, attributeNamePrefix: '' });
    return parser.parse(xmlString);
}


function convertNodeToHtml(node, imageMap) {
    if (Array.isArray(node)) {
        return node.map(item => convertNodeToHtml(item, imageMap)).join('');
    }

    if (typeof node === 'object' && node !== null) {

        if (node['text:p']) {
            const paragraphs = Array.isArray(node['text:p']) ? node['text:p'] : [node['text:p']];
            return paragraphs.map(p => `<p>${convertNodeToHtml(p, imageMap)}</p>`).join('');
        }


        if (node['draw:frame']) {
            const frames = Array.isArray(node['draw:frame']) ? node['draw:frame'] : [node['draw:frame']];
            return frames.map(frame => {
                const image = frame['draw:image'];
                const href = image?.['xlink:href'];
                if (href && imageMap[href]) {
                    const src = imageMap[href];
                    return `<img src="${src}" alt="" style="max-width:100%;" />`;
                }
                return '';
            }).join('');
        }


        if (node['text:span']) {
            const spans = Array.isArray(node['text:span']) ? node['text:span'] : [node['text:span']];
            return spans.map(span => {
                if (typeof span === 'string') return span;
                if (span['#text']) return span['#text'];
                return convertNodeToHtml(span, imageMap);
            }).join('');
        }


        if (node['#text']) {
            return node['#text'];
        }


        return Object.values(node).map(child => convertNodeToHtml(child, imageMap)).join('');
    }

    return typeof node === 'string' ? node : '';
}

async function convertOdtToHtml(file, isEmbedding, abortedFiles) {

    const buffer = await file.arrayBuffer();
    if (handleAbort(file, abortedFiles, isEmbedding)) {
        return [];
    }
    const zip = await extractOdtZip(buffer);
    const imageMap = await extractImages(zip, file, isEmbedding, abortedFiles);
    if (handleAbort(file, abortedFiles, isEmbedding)) {
        return [];
    }
    const contentXml = await extractContentXml(zip);
    if (handleAbort(file, abortedFiles, isEmbedding)) {
        return [];
    }
    const jsonObj = await parseContentXml(contentXml);
    if (handleAbort(file, abortedFiles, isEmbedding)) {
        return [];
    }
    const officeText = jsonObj['office:document-content']?.['office:body']?.['office:text'];
    if (!officeText) throw new Error('Document text not found in content.xml');

    const fullHtml = convertNodeToHtml(officeText, imageMap);
    const chunks = HtmlParsing.splitHtmlIntoChunks(fullHtml);

    return chunks;
}

export { convertOdtToHtml };